import i18n from '@/plugins/vuei18n'

export default {
  COMPLETED: 1,
  SAVED: 2,
  ARCHIVED: 3,
  states : [
     { name: i18n.t('states.all'), value: 0 },
     { name: i18n.t('states.completed'), value: 1 },
     { name: i18n.t('states.saved'), value: 2 },
     { name: i18n.t('states.archived'), value: 3 }
  ]
}
